import { createAsyncThunk } from "@reduxjs/toolkit"
import { Axios, HttpClient } from "../adapters/xhr/httpClient"
import { HttpRequestType } from "../adapters/xhr/RequestStatus";
// import { v4 as uuidv4 } from 'uuid';


export function AsyncThunkAction (thunkActionName, url, method = HttpRequestType.POST, headers = {}){
    return createAsyncThunk(
        thunkActionName,
        async (payload, { signal, getState }) => {
            const source = Axios.CancelToken.source()
            signal.addEventListener('abort', () => {
                source.cancel()
            })
            let token = getState().auth.token
            // if(!token || token=='undefined' || thunkActionName=='auth/form'){
            //     token = uuidv4()
            // }
            const response = await HttpClient.ANY(method ,url, {
                headers: { headers, authorization: token },
                data: payload,
                cancelToken: source.token,
            })
            return response
        }
    )
}


export function AsyncThunkActionWithFetch(thunkActionName, url, method = HttpRequestType.POST, headers = {}) {
    return createAsyncThunk(
        thunkActionName,
        async (payload, { signal, getState }) => {
            const source = Axios.CancelToken.source()
            signal.addEventListener('abort', () => {
                source.cancel()
            })
            const token = getState().auth.token
            const response = await fetch(url,
                {
                    method: method,
                    headers: {
                        "Content-Type": "application/json",
                        'authorization': token
                    },
                    body: JSON.stringify(payload)
                })
            return response
        }
    )
}